import { Injectable } from "@angular/core";
import { FormControl, FormControlStatus, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { filter } from "rxjs";
import { DebitCardImagesListService } from "src/app/common/services/debit-card-image-list/debit-card-image-list.service";
import { BaseFpxFormHelper, BaseFpxComponentState, BaseFpxChangeHandler } from "src/app/common/utils/base-fpx.form.component";
import { CustomerService } from "src/app/services/customer.service";
import { TransfersService } from "src/app/services/transfers/transfers.service";
import { Beneficiary } from "../models/beneficiary-list.model";
import { BeneficiaryListService } from "./beneficiary-list.service";

export class BeneficiaryListState extends BaseFpxComponentState {

}

@Injectable({
    providedIn :'root'
})
export class BeneficiaryListHelper extends BaseFpxFormHelper<BeneficiaryListState> {
    // private _beneList:any = [];

    constructor( public transferService:TransfersService,
        public customerService:CustomerService,
        public translate: TranslateService) {
        super(new BeneficiaryListState());
    }

    public doConfirm(context: any, success: any, failure: any) {

    }
    // fetchBeneList(callback = null) {
    //     this.beneficiaryListService.fetchBeneList().subscribe((res)=>{
    //         this._beneList = res.beneficiary.filter((item)=>{
    //            return item.status == '1'
    //         });
    //         if(callback) callback(this._beneList)
    //     })
    // }
    // getBeneList(callback = null) {
    //     if(this._beneList.length) return this._beneList;
    //     else { 
    //         this.fetchBeneList((res)=>{
    //             callback(res);
    //         });
    //     }
    // }
    // deleteBene(beneId, callback) {
    //     this._beneList = [];
    //     this.beneficiaryListService.deleteBene(beneId).subscribe((res)=>{
    //         callback(res);
    //     })
    // }
    // getBeneListByType(paymentSystem, callback = null):any {
    //     if(!this._beneList.length) {
    //         this.getBeneList((res)=>{
    //             this._beneList = res;
    //             callback(this._beneList.filter((item)=>{
    //                 return item.paymentSystem == paymentSystem
    //             }))
    //         });
    //     }
    //     else {
    //         return this._beneList.filter((item)=>{
    //             return item.paymentSystem == paymentSystem
    //         })
    //     }
    // }
    // getActiveBeneById(beneId, callback = null) {
    //     if(!this._beneList.length) {
    //         this.fetchBeneList((res)=>{
    //             callback(res.filter((item)=>{
    //                 return item.beneId == beneId
    //             })[0])
    //         });
    //     }
    //     else {
    //         return this._beneList.filter((item)=>{
    //             return item.beneId == beneId
    //         })[0]
    //     }
    // }
    // getGrpByBeneList(paymentSystem, callback) {
    //     if(!this._beneList.length) {
    //         this.fetchBeneList((res)=>{
    //             this._beneList = res;
    //             let typeFilteredBene = this.getBeneListByType(paymentSystem);
    //             callback(this.getGroupByArray(this.getSortedArray(typeFilteredBene, 'beneName'), 'beneName'));
    //         });
    //     }
    //     else {
    //         let typeFilteredBene = this.getBeneListByType(paymentSystem);
    //             callback(this.getGroupByArray(this.getSortedArray(typeFilteredBene, 'beneName'), 'beneName'));
    //     }
    // }

    // getSortedArray(arr,sortByName) {
    //     return arr.sort( function( a, b ) {
    //         a = a[sortByName]?.toLowerCase();
    //         b = b[sortByName]?.toLowerCase();
    //         return a < b ? -1 : a > b ? 1 : 0;
    //     });
    // }
    // getGroupByArray(arr,groupByName) {
    //     let data = arr.reduce((r, e) => {
    //         let group = e[groupByName][0];
    //         if(!r[group]) r[group] = {group, children: [e]}
    //         else r[group].children.push(e);
    //         return r;
    //       }, {})
    //     return Object.values(data);
    // }
}